// app/javascript/controllers/page_header_controller.js
import { Controller } from "@hotwired/stimulus"

const DESKTOP_MIN_WIDTH = 750
const NO_OVERSCROLL_SCROLL_TOP = 50
const DISPLAY_TITLE_OFFSET = 22

export default class extends Controller {
  static targets = ["mainHeader", "secondaryHeader", "secondaryTitle"]

  connect() {
    if (!this.hasMainHeaderTarget || !this.hasSecondaryHeaderTarget || !this.hasSecondaryTitleTarget) return

    this.mainClassList = this.mainHeaderTarget.classList
    this.rootClassList = document.documentElement.classList
    this.root = document.documentElement

    this.rafId = 0
    this.onScroll = () => this.scheduleUpdate()

    if (window.innerWidth >= DESKTOP_MIN_WIDTH) {
      this.initDesktop()
      return
    }

    this.mainPaddingBottom = parseFloat(getComputedStyle(this.mainHeaderTarget).paddingBottom) || 0
    this.displayTitleThreshold = this.secondaryTitleTarget.offsetHeight * 2 + this.mainPaddingBottom * 2 - DISPLAY_TITLE_OFFSET

    this._hasDisplayTitle = undefined
    this._hasBorderBottom = undefined
    this._hasGlassEffect = undefined
    this._noOverscroll = undefined

    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.update()
  }

  disconnect() {
    if (this.onScroll) {
      window.removeEventListener("scroll", this.onScroll)
    }

    if (this.rafId) {
      cancelAnimationFrame(this.rafId)
      this.rafId = 0
    }
  }

  scheduleUpdate() {
    if (this.rafId) return

    this.rafId = requestAnimationFrame(() => {
      this.rafId = 0
      this.update()
    })
  }

  update() {
    const headerRect = this.secondaryHeaderTarget.getBoundingClientRect()
    const titleRect = this.secondaryTitleTarget.getBoundingClientRect()

    const hasDisplayTitle = titleRect.bottom < this.displayTitleThreshold
    const hasBorderBottom = headerRect.top < this.mainPaddingBottom
    const hasGlassEffect = headerRect.top < -this.mainPaddingBottom

    if (this._hasDisplayTitle !== hasDisplayTitle) {
      this._hasDisplayTitle = hasDisplayTitle
      this.mainClassList.toggle("has-display-title", hasDisplayTitle)
    }

    if (this._hasBorderBottom !== hasBorderBottom) {
      this._hasBorderBottom = hasBorderBottom
      this.mainClassList.toggle("has-border-bottom", hasBorderBottom)
    }

    if (this._hasGlassEffect !== hasGlassEffect) {
      this._hasGlassEffect = hasGlassEffect
      this.mainClassList.toggle("has-glass-effect", hasGlassEffect)
    }

    this.updateOverscrollState()
  }

  updateOverscrollState() {
    const noOverscroll = (window.scrollY || this.root.scrollTop || document.body.scrollTop || 0) > NO_OVERSCROLL_SCROLL_TOP

    if (this._noOverscroll === noOverscroll) return

    this._noOverscroll = noOverscroll
    this.rootClassList.toggle("no-overscroll", noOverscroll)
  }

  initDesktop() {
    this.mainClassList.add("has-display-title", "has-border-bottom", "has-glass-effect")
    this.rootClassList.remove("no-overscroll")
  }
}
